import { Fragment, useContext } from "react";
import { Outlet, Link } from "react-router-dom";

import { UserContext } from "../../../model/contexts/user.context";

import "./NavBar.scss";

import { ReactComponent as CompanyLogo } from "../../../assets/company-logo.svg";

const NavBar = () => {
  return (
    <div className="navbar-container">
      <Link className="navbar-logo-container" to="/auth">
        <div className="navbar-logo-content">
          <CompanyLogo className="company-logo" />
          <span className="company-logo-text"> Postly </span>
        </div>
      </Link>
      <div className="navbar-menu-container">
        {/* Add nav items or buttons here */}
      </div>
    </div>
  );
};

export default NavBar;
